<template>
    <div>
        <ui-icon-button ref="button" has-dropdown icon="face" type="secondary" style="vertical-align: middle;" tooltip="Assign to User">
            <div slot="dropdown">
                <div class="container-fluid" style="max-height: 80vh; overflow-y: auto;">
                    <div @click="unassignAll" class="row align-items-center">
                        <avatar class="col" :contact="{ primary_display_as: 'Unassigned' }"></avatar>
                        <div class="col-6">Unassigned</div>
                        <div class="col"><span v-if="isUnassigned" class="material-icons">check</span></div>
                    </div>
                    <div @click="toggleStatus(user)" v-for="user in availableUsers" class="row align-items-center">
                        <avatar class="col" :user="user"></avatar>
                        <div class="col-6">{{ user.name }}</div>
                        <div class="col"><span v-if="isAssignedUser(user)" class="material-icons">check</span></div>
                    </div>
                </div>
            </div>
        </ui-icon-button>
    </div>
</template>

<script>
import {LeadResource, LeadStatuses} from "../../classes/Api/Lead";

    export default {
        props: {
            conversations: {
              type: Array,
              required: true
            },
            availableUsers: {
                type: Array,
                required: true
            }
        },
        computed: {
            isUnassigned() {
                return this.conversations.length === 1 && this.assignedUsers.length === 0
            },
            assignedUsers() {
                return this.conversations.length === 1 ? this.conversations[0].assignees : []
            }
        },
        methods: {
            isAssignedUser(user) {
                return !!this.assignedUsers.find(i => i.id === user.id)
            },
            unassignAll() {
                let promises = []
                for (let i in this.conversations) {
                    promises.push(this.$store.dispatch(
                        'inbox/conversations/unassignAll', {
                            conversation_id: this.conversations[i].id,
                        }
                    ))
                }

                Promise.all(promises).then(() => {
                    this.$emit('changed')
                })
            },
            toggleStatus(user) {
                let promises = []

                for (let i in this.conversations) {
                    if (!this.isAssignedUser(user)) {
                        promises.push(new Promise((resolve, reject) => {
                            // Assign the conversation.
                            this.$store.dispatch(
                                'inbox/conversations/assign', {
                                    conversation_id: this.conversations[i].id, user_id: user.id
                                }
                            )

                            // Decide whether we need to ask the user whether they also want to assign
                            // the conversation owners active leads.
                            .then(() => {
                                let filters = {
                                    'lead.status': LeadStatuses.ACTIVE,
                                    'lead.conversation': this.conversations[i].id,
                                }

                                LeadResource.all({filters}).then((r) => {
                                    let contactName =  this.conversations[i].contact.primary_display_as
                                    let message = 'This conversation has an active lead, do you also want '
                                        + 'to assign the lead to \'' + user.name + '\'?'

                                    if (r.data.results.length > 0 && confirm(message)) {
                                        let promises = []

                                        r.data.results.forEach(lead => {
                                            promises.push(LeadResource.update(lead.id, {'owner_id': user.id}))
                                        })

                                        Promise.all(promises).then(() => {
                                            if (this.$refs.button) {
                                                this.$refs.button.closeDropdown()
                                            }
                                            resolve()
                                        }).catch(e => handleApiError(e, reject))
                                    } else {
                                        if (this.$refs.button) {
                                            this.$refs.button.closeDropdown()
                                        }
                                        resolve()
                                    }
                                })
                            })
                        }))
                    } else {
                        promises.push(this.$store.dispatch(
                            'inbox/conversations/unassign', {
                                conversation_id: this.conversations[i].id, user_id: user.id
                            }
                        ))
                    }
                }

                Promise.all(promises).then(() => {
                    this.$emit('changed')
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container-fluid {
        width: 270px;

        .row {
            border-top: 1px solid #eee;
            padding-top: .5rem;
            padding-bottom: .5rem;
            cursor: pointer;

            &:hover { background: #f8f8f8; }
        }

        .material-icons { vertical-align: middle; }
    }
</style>